module.exports = __webpack_public_path__ + "front/img/60_a.29e1b678.png";